import { setTitleByDimension } from 'shared/utils/titles'
import PropTypes from 'prop-types'
import React from 'react'
import moment from 'moment'

import styles from './Tooltip.module.scss'

const sortByValue = (a, b) => a.value < b.value
  ? 1
  : a.value > b.value
    ? -1
    : 0

const Tooltip = chartProps => ({ label, payload }) => {
  const isZeroValuePayload = payload.every(item => item.value === 0)
  if(isZeroValuePayload) return null

  return (
    <main className={styles.wrapper}>
      <header className={styles.label}>
        {moment(label).format('MMM D')}
      </header>

      {
        payload
          .filter(item => item.value > 0)
          .sort(sortByValue)
          .map((item, i) => {
            const dimensionValue = item.name.split(',')[0]
            const title = chartProps?.customTitleDimensionMapper
              ? chartProps?.customTitleDimensionMapper(dimensionValue)
              : setTitleByDimension(dimensionValue, [ chartProps?.tooltipDimension || 'channelname' ])

            return (
              <div
                key={i}
                className={styles.item}
                style={{
                  color: item.color
                }}
              >
                <span>
                  {title}:
                </span>

                <span className={styles.itemValue}>
                  {item.value}
                </span>
              </div>
            )
          })
      }
    </main>
  )
}

Tooltip.propTypes = {
  label: PropTypes.string,
  payload: PropTypes.array
}

export default Tooltip
